import React, { useContext } from "react";
import { PopupContext } from "../../index";
import { POPUP_TYPES, getConfirmPopup } from "../../view/popup/PopupContainer";
import { HelpCircle } from 'lucide-react';

export function FAQLink() {
    const { setPopup } = useContext(PopupContext);

    const handleHelp = () => setPopup(
        {
            type: POPUP_TYPES.ABOUT,
            confirm: getConfirmPopup
        }
    );

    return (
        <button
            className="icon-btn"
            onClick={handleHelp}
            title="Help"
        >
            <HelpCircle className="btn-icon" />
        </button>
    )
}